var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 19,
    viewBox: "0 0 31 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95819 18.075C7.60171 14.4315 11.2452 10.788 14.8886 7.14459C15.1776 6.85559 15.7556 6.85559 16.0447 7.14459L26.9751 18.075C27.293 18.3929 27.8132 18.3929 28.1311 18.075L30.4282 15.778C30.7462 15.46 30.7462 14.9398 30.4282 14.6219L16.0447 0.23844C15.7267 -0.0794799 15.2065 -0.0794799 14.8886 0.23844L0.505148 14.6219C0.187168 14.9399 0.187168 15.4601 0.505148 15.778L2.80212 18.075C3.11998 18.3928 3.64027 18.3929 3.95819 18.075Z",
    fill: "#B1C9EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3702 14.6221L16.0443 8.29606C15.7263 7.97814 15.2061 7.97814 14.8882 8.29606L8.56217 14.6221C8.24425 14.94 8.24425 15.4602 8.56217 15.7782L10.8592 18.0751C11.1771 18.3931 11.6973 18.3931 12.0153 18.0751C12.9729 17.1175 13.9306 16.1599 14.8882 15.2023C15.1772 14.9133 15.7552 14.9133 16.0443 15.2023L18.9171 18.0751C19.2351 18.3931 19.7553 18.3931 20.0732 18.0751L22.3702 15.7782C22.6882 15.4602 22.6882 14.94 22.3702 14.6221H22.3702Z",
    fill: "#316DB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small_logo.166d9575bba14bbb1d60cbee892b7c6d.svg";
export { ForwardRef as ReactComponent };